export const districtUsageIntroSteps = (isDistrict: boolean = false) => [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#schoolFilter',
    intro: 'Select a school from the dropdown to view WordFlight usage data for that school.',
  },
  {
    element: '#printButton',
    intro: isDistrict
      ? 'Click here to print the WordFlight Usage report for the select school(s).'
      : 'Click here to print the WordFlight Usage report for the selected school.'
  },
  {
    element: '.dashboard-header-bar',
    intro: 'Usage Detail is where you can view WordFlight System usage data. You can see WordFlight System enrollment, usage trends, weekly time goals, and more.'
  },
  {
    element: '#district-report-school-guidance',
    intro: 'See the school guidance for tips on how to use this report.',
  },
  {
    element: '#district-report-usage-trend',
    intro: isDistrict
      ? 'See the graph which shows the average minutes per week trend across the school year for the district.'
      : 'See the graph which shows the average minutes per week trend across the school year for the school.',
  },
  {
    element: '#enrollment-numbers',
    intro: 'See the number of students enrolled in the WordFlight System.'
  },
  {
    element: '#loginDateRange',
    intro: 'Select a date range from the dropdown to view WordFlight System usage data for that week.'
  },
  {
    element: '#school-engagement',
    intro: 'See the number of schools that had 70% of students hit their minimum weekly time goal for the selected date range.',
  },
  {
    element: '#teacher-engagement',
    intro: 'See the number of teachers that had 70% of students hit the weekly time goal for the selected date range.',
  },
  {
    element: '#weeklyTimeGoal',
    intro: 'See the average weekly usage in minutes, the minimum weekly usage goal in minutes, and the distribution of student usage within the selected date range.'
  },
];
